/* global urlify getPageUrl */
import $ from "jquery";
import language from "#scripts/translation";
import { articlesExtend, setCorrectTemplate, urlify, getPageUrl } from "#scripts/general_functions";
import { decodeIfNeeded } from "#templates/pages/content";
import { getLangForApi } from "#scripts/cmsapi.js";

// GET, SET
export const getStoredNav = () => {
	/*
		Gets the categories from SessionStorage, parse them and return as JSON
		*/
	return JSON.parse(sessionStorage.getItem("aim-categories"));
};

export const storeNav = (_categories) => {
	let categories = _categories;
	/*
		Receive cateogories (initiated in app.js). Process data and concats it with the articlecount.
		Store result in Session Storage, parsed as string.
		*/

	const loopCategories = (categories, parent) => {
		// loops trought the categories and place the aritcle count on each category. Calls itself on child.
		// return as JSON

		const count = 0;
		$.each(categories, (nr, data) => {
			// $.each(counts, function () {
			//   if ($(this)[0].value === data.categoryId) {
			//     // count = $(this)[0].key;
			//   }
			// });

			// check children_names as replacement for category description.
			let names = [];
			$.each(data.children, (childrenNr, childrenData) => {
				if (!childrenData.hideCategory) {
					names.push(childrenData.previewItem ? childrenData.previewItem : childrenData.item);
				}
			});
			names = names.join(", ");

			// sets additional data
			const internurl = data.previewItem ? data.previewItem : data.item;
			data.looped = true;
			data.articles = count;
			data.urlified = urlify(internurl.toLowerCase());

			data.desc = data.description;
			if (data.description === " " || data.description === null || data.description === "") {
				data.desc = names;
			}

			if (parent) {
				data.full_url = `${parent.full_url}/${urlify(internurl.toLowerCase())}`;
			} else {
				data.full_url = urlify(internurl.toLowerCase());
			}

			// initiate drilldown on children
			if (data.children) {
				if (data.children.length > 0) {
					loopCategories(data.children, data);
				}
			}
		});

		return categories;
	};

	categories = loopCategories(categories);
	sessionStorage.setItem("aim-categories", JSON.stringify(categories));
};

export const getNavPosition = (searchfor) => {
	/*
		Creates a array of a single "cateogory".
		Return as Array
		*/

	const navs = getStoredNav();
	const returnValues = [];

	traverseNavigation(navs, searchfor, returnValues);

	return returnValues;
};

export const traverseNavigation = (navs, searchfor, returnValues) => {
	$.each(navs, (nr, nav) => {
		const searchParts = searchfor.split("/");
		if (nav.full_url === searchfor) {
			// Found it, you can quit now
			returnValues.push(nav);
			return false;
		}
		if (searchParts.includes(nav.urlified)) {
			returnValues.push(nav);
			traverseNavigation(nav.children, searchfor, returnValues);
		}
	});
};

export const getNavArticles = (category) => {
	/*
		Get articles from current cateogry.
		Return HTML injection.
		*/
	const config = JSON.parse(sessionStorage.getItem("config"));
	// const senddata = JSON.stringify({
	// 	categoryId: category,
	// 	subscriptionId: config.clientId,
	// });
	// let settings = {
	// 	type: "POST",
	// 	url: `${window.apiUrl}/PublicContentApi/getbycategoryidasstring`,
	// 	contentType: "application/json-patch+json",
	// 	data: senddata,
	// };

	const defaultContentTypes = [
		"5be9ba0d-3682-4493-9587-306a99911bf3", // mal_artikkel
		"93847071-c959-4ce5-a79a-686af7dbd419", // mal_enhet
		"8ee596e3-98cc-43e0-b785-96cc6325773c", // Artikkel m/bilde
		"1bb71f41-4ee6-4394-b78f-3202e2f5eeda", // Transportside
		"e662f30f-ecd9-4974-8657-35b726365572", // Temaside
		"fd54728e-1956-433b-a33b-a7f95023dd37", // Fokusartikkel
		"453b9f75-ff2f-41cb-8504-04572637d756", // ExternalNavLink
	];
	let settings = {
		type: "GET",
		url: `${window.apiUrl}/Public/articles?subscriptionId=${config.clientId}&category=${category}&language=${getLangForApi()}&contentTypes=${defaultContentTypes.join(
			",",
		)}&limit=100&getRecursiveContent=true&sortBy=Title&LanguageMode=Strict`,
		data: "",
	};

	$.ajax(settings)
		.fail(() => {
			$(".temp__spinner").remove();
			console.log("API call failed...");
		})
		.done((_alle) => {
			const allArticles = [];
			let allUnits = [];
			if (settings.url.includes("PublicContentApi")) {
				_alle.sort((a, b) => a.title.localeCompare(b.title, "no"));
			}
			const alle = _alle.listOfContent;
			$.each(alle, (nr, _article) => {
				let article = _article;
				// Handle intro textx

				// Intro step 1: Get intro, reduce to max 100 char.
				let intro = article.intro || "";

				// Intro step 2: Set Intro to tags
				if (intro === "") {
					let tags = [];
					$.each(tags, (n, tag) => {
						let title = tag.title;
						title = title.charAt(0).toUpperCase() + title.slice(1);
						tags.push(title);
					});
					tags = tags.join(" - ");

					intro = tags;
				}

				// let content = decodeURIComponent(article.contentObject);
				let content = decodeIfNeeded(article.contentObject);

				// intro step 3: Set intro to block headers.
				// if (intro === "") {
				// 	const parts = [];
				// 	const reg = /\[.*\]/g;
				// 	let result = reg.exec(content);
				// 	while ((result = reg.exec(content)) !== null) {
				// 		parts.push(result);
				// 	}
				// 	intro = parts.join(" - ");
				// }

				// intro step 4: get first 100 char from article
				if (intro === "") {
					function stripHtml (html) {
						const tmp = document.createElement("DIV");
						tmp.innerHTML = html;
						return tmp.textContent || tmp.innerText || "";
					}

					content = stripHtml(content);
				}

				if (intro.length >= 1) {
					// intro cleanup
					intro = intro.replace(/\[|\]/gi, "");
				}
				if (intro.length >= 100) {
					intro = `${intro.slice(0, 97)}...`;
				}
				const desc = intro || "";

				article = articlesExtend(article);

				if (article.metaParsed && article.pageTypeId === "mal_dynamisk") {
					const metaArticleTypeId = setCorrectTemplate(article.metaParsed);
					if (metaArticleTypeId) {
						article.pageTypeId = metaArticleTypeId;
					}
				}

				if (
					article.pageTypeId !== "mal_blokk" &&
					article.pageTypeId !== "mal_dynamisk" &&
					article.pageTypeId !== "mal_nyhet" &&
					article.pageTypeId !== "bti-forside" &&
					!article.isVisibleInNavigation === false
				) {
					const nav = {
						article,
						item: article.title, // + `(${article.contentTypeGuid})`,
						articles: 0,
						desc,
						type: article.pageTypeId,
					};

					if (nav.type !== "mal_enhetsmal") {
						allArticles.push(menuItemHtml(nav, true));
					} else {
						allUnits.push(menuItemHtml(nav, true));
					}
				}
			});

			const allUnitsLength = allUnits.length;
			allUnits = allUnits.join("");

			$("#menuitems").append(allArticles.join(""));

			if (allUnitsLength > 0) {
				if (allArticles.length !== 0 && language("NAV_UNITS_IN_MUNIC").trim() !== "") {
					$("#menuitem_link").html(`
                <a href='#allunits' class="fullnav__allunitslink"><span class='material-icons-outlined notranslate'></span>${language("NAV_UNITS_IN_MUNIC")}</a>
            `);
				}
				let unitTitle = "";
				if (language("NAV_UNITS_IN_MUNIC").trim() !== "") {
					unitTitle = `<div class="row"><div class="col"><h2 id='allunits' class="unitscontainer fullnav__unitheader">${language("NAV_UNITS_IN_MUNIC")}</h2></div></div>`;
				}

				$(unitTitle).insertBefore("#menu_units");
				$("#menu_units").append(`
                <!--div class="unitscontainer col-12">      
                    <div class="units">
                        <div class="row"--->
                            ${allUnits}
                        <!--/div>
                    </div>
                </div-->
            `);
			}

			$(".temp__spinner").remove();
		});
};

export const navPage = () => {
	let breadcrumbs = [];
	// get categoryposition
	const path = getNavPosition(getPageUrl().contentid);
	let last;

	// set breadcrumbs based on position
	$.each(path, (nr, page) => {
		let bclink = `<a href="/nav/${page.full_url}" class="fullnav__breadcrumb__link">${page.previewItem ? page.previewItem : page.item}</a>`;

		if (window.location.pathname === `/nav/${page.full_url}`) {
			bclink = `<span class="fullnav__breadcrumb__link">${page.previewItem ? page.previewItem : page.item}</span>`;
		}

		breadcrumbs.push(`
            <li class="aim-breadcrumb-item">${bclink}</li>
        `);

		last = page;
	});

	breadcrumbs = breadcrumbs.join("");

	let menuItems = [];

	let rekPreditions = "";
	if (window.serverdata.configMeta.aim?.rek?.navPage?.showOnNavPage) {
		// Call the predict method on the __rekai object

		const _options = window.serverdata.configMeta.aim?.rek?.navPage;
		let subtree = "";
		if (last !== undefined) {
			subtree = `/nav/${last.full_url}`;
			// subtree = last.previewItem ? last.previewItem : last.item;
		}
		const options = { overwrite: { addcontent: true, subtree: subtree, nrofhits: _options.nrofhits || 6 } };
		window.__rekai.predict(options, (data) => {
			const predictions = data.predictions;
			if (predictions.length > 0) {
				let tmpHtml = "<ul>";
				for (const prediction of predictions) {
					tmpHtml = `${tmpHtml}<li><a href="${prediction.url}">${prediction.title}</a></li>`;
				}
				tmpHtml = `${tmpHtml}</ul>`;
				document.querySelector(".rek-predictions").insertAdjacentHTML("beforeend", tmpHtml);

				const siblings = document.querySelectorAll(".pill");
				for (const sibling of siblings) {
					sibling.classList.remove("d-none");
				}
			}
		});
		rekPreditions = `<div class="rek-title pill d-none">Mye besøkt nå</div><div class="rek-predictions pill d-none"></div><div class="rek-title2 pill d-none">Meny</div>`;
	}

	// fallback if no position, initate main-menu
	if (typeof last === "undefined") {
		last = {
			item: language("NAV_MAINMENU"),
			desc: "",
			description: "",
			id: "",
		};
		menuItems = headerNav(true);
	} else {
		$.each(last.children, (nr, childItem) => {
			if (!childItem.hideCategory && childItem.type !== "mal_enhetsmal" && !childItem.previewItem.startsWith("_") && !childItem.item.startsWith("_")) {
				menuItems.push(menuItemHtml(childItem, true));
			}
		});

		menuItems = menuItems.join("");
	}
	document.title = last.previewItem ? last.previewItem : last.item;
	getNavArticles(last.categoryId);

	const r = `     

        <div class="container p-md-0">
            <div class="row">
                <div class="col">
                    <div class="fullnav__breadcrumb__container">
                        <nav aria-label="breadcrumb">
                          <ol class="aim-breadcrumb fullnav__breadcrumb"  id="full__breadcrumb">

                            <li class="aim-breadcrumb-item"><a href="/" class="fullnav__breadcrumb__link">${language("NAV_FRONTPAGE")}</a></li>
                            <!--li class="aim-breadcrumb-item"><a href="/nav" class="fullnav__breadcrumb__link">${language("NAV_ALLCATEGORIES")}</a></li-->
                            ${breadcrumbs}
                          </ol>
                          <!-- warning position -->
                        </nav>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="fullnav__header">
                        <h1>${last.previewItem ? wrapOnSlashes(last.previewItem) : wrapOnSlashes(last.item)}</h1>
                        ${last.description && !window.serverdata.configMeta.aim?.rek?.navPage?.showOnNavPage ? last.description : ""}
												${rekPreditions}
                        <div id="menuitem_link"></div>
                    </div>
                </div>
            </div>
            <div class="xrow" id="menuitems">
                ${menuItems}
                
                <div class="temp__spinner col-sm-12 text-center">
                    <div class="spinner-border" role="status" >
                      <span class="sr-only">Loading...</span>
                    </div>
                </div>
                
            </div>
            <div class="xrow" id="menu_units">

            </div>
            <div class="row" id="nav__items">
            </div>
        </div>

    `;

	return r;
};

export const menuItemHtml = (nav, reversed = false) => {
	/*
	Create a reusable HTML element for nav Item.
	Contains logic to seperate href and color-variations
	Return HTML
	*/
	let href = `/nav/${nav.full_url}`;
	const article = nav.article || false;
	let target = '""';
	let isRealExternalLink = false;
	if (article) {
		href = `/artikkel/${article.nameInUrl || article.contentId}`;
		if (nav.type === "externalnavlink") {
			const url = nav.article.metaDynamic["Ekstern lenkeadresse / URL"];
			href = url;
			target = `aria-label="${nav.previewItem ? wrapOnSlashes(nav.previewItem) : wrapOnSlashes(nav.item)}${nav.articles > 0 ? " " : ""} (${language("NAV_OPEN_I_NEW")})" target="_blank"`;
		}
	} else if (nav.externallink) {
		href = nav.externallink;
		const regex = /^https?:\/\//;
		if (regex.test(nav.externallink)) {
			isRealExternalLink = true;
			nav.type = "externallink";
			target = `aria-label="${nav.previewItem ? wrapOnSlashes(nav.previewItem) : wrapOnSlashes(nav.item)}${nav.articles > 0 ? " " : ""} (${language("NAV_OPEN_I_NEW")})" target="_blank"`;
		}
	}

	nav.desc = nav.desc.replace(/Blokk:/gim, ". ");
	const navCols = window.serverdata.configMeta.aim.style?.fullnav__row_wide ? 2 : 3;
	const transCols = window.serverdata.configMeta.aim.style?.transport__row_wide ? 2 : 3;
	const externallinkCols = window.serverdata.configMeta.aim.style?.fullnav__externallink__row_wide ? 2 : 3;
	let cols = reversed ? transCols : navCols;
	cols = isRealExternalLink ? externallinkCols : cols;
	const menuIcons = window.serverdata.configMeta.aim.menuIcons;

	let icon = `<span class="material-icons-outlined notranslate menu-icon${menuIcons ? " menu-custom-icon" : ""}${isRealExternalLink ? " externallink" : ""}"></span>`;
	// if (!reversed && menuIcons && Object.prototype.hasOwnProperty.call(menuIcons, nav.categoryId) && Object.prototype.hasOwnProperty.call(menuIcons[nav.categoryId], "icon")) {
	if (!reversed && menuIcons?.[nav.categoryId]?.icon) {
		let customIcon = `<img src="${menuIcons[nav.categoryId].icon}" role="presentation" loading="lazy"/>`;
		if (menuIcons[nav.categoryId].icon.startsWith("<svg")) {
			customIcon = menuIcons[nav.categoryId].icon;
		}
		icon = `<span class="menu-custom-icon">${customIcon}</span>`;
	}

	return `<!--div class="col-lg-${cols === 2 ? 6 : 4} col-md-6 mb-3 mb-lg-4 p-0" data-name="${urlify(nav.item)}"-->
          <div data-name="${urlify(nav.item)}">
              <a href="${href}" ${target} class="fullnav__main__item h-100 ${reversed ? "fullnav__main__item-reversed" : ""} fullnav__main__item-${nav.type}">
                  <h2 class="fullnav__main__title">${icon}<span class="fullnav__main__titletext">${nav.previewItem ? wrapOnSlashes(nav.previewItem) : wrapOnSlashes(nav.item)}${nav.articles > 0 ? " " : ""}</span></h2>
                  ${nav.desc ? `<p>${nav.desc}</p>` : ""}
              </a>
          </div>`; // (${nav.articles})
};

export const headerNav = (reversed = false) => {
	/*
		Create main navigation to header and "empty site"
		Simple logic to work with two styles with "reversed"
		Return HTML.
		*/

	const navs = getStoredNav();
	let menuItems = [];
	const menuItemsExternallinks = [];

	$.each(navs, (nr, nav) => {
		if (nav.externallink) {
			nav.type = "articlelink";
			const regex = /^https?:\/\//;
			if (regex.test(nav.externallink)) {
				nav.type = "externallink";
			}
		}
		if (!nav.hideCategory && nav.type !== "mal_enhetsmal" && !nav.previewItem.startsWith("_") && !nav.item.startsWith("_")) {
			menuItems.push(menuItemHtml(nav, reversed));
		} else if (!nav.hideCategory && nav.type === "externallink" && !nav.previewItem.startsWith("_")) {
			menuItemsExternallinks.push(menuItemHtml(nav, reversed));
		}
	});

	menuItems = menuItems.join("");
	if (menuItemsExternallinks) {
		menuItems = `${menuItems}<div class="col-12 menu-spacer"></div>${menuItemsExternallinks.join("")}`;
	}

	return menuItems;
};

export const findCategoryPaths_old = (categories, categoryId, path = [], urlPath = []) => {
	for (let category of categories) {
		let currentPath = [...path, category.previewItem];
		let currentUrlPath = [...urlPath, category.externallink || category.full_url];
		if (category.categoryId === categoryId) {
			return { path: currentPath, urlPath: currentUrlPath };
		}
		if (category.children) {
			const result = findCategoryPaths(category.children, categoryId, currentPath, currentUrlPath);
			if (result) {
				return result;
			}
		}
	}
	return null;
}
export const findCategoryPaths = (categories, categoryId, path = [], urlPath = []) => {
	for (let category of categories) {
		const currentPath = [...path, category.previewItem];
		const currentUrlPath = [...urlPath, category.externallink || category.full_url];

		if (category.categoryId === categoryId) {
			return { path: currentPath, urlPath: currentUrlPath };
		}

		if (category.children && category.children.length) {
			const result = findCategoryPaths(category.children, categoryId, currentPath, currentUrlPath);
			if (result) return result;
		}
	}
	return null;
};

function wrapOnSlashes (str) {
	return str.replace(/\//g, "/<wbr>");
};
